export const NAMESPACE = 'orderReturns';
export const NAME = 'data';
